import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {checkEmailWithAPI, updateEmailAddress} from '../../../v2/actions/emailAddressActions';
import emailFieldDefinition from '../../../v2/components/address/field-validation/defaultFieldDefinitions/Email';
import FieldContainer2 from '../../../v2/form/FieldContainer2';
import InputField from '../../../v2/form/InputField';
import Translation from '../../../v2/lang/Translation';
import getAutocompleteStatus from '../../../v2/selectors/getAutocompleteStatus';
import getShouldCallAPIForMarketingPreferences from '../../../v2/selectors/getShouldCallAPIForMarketingPreferences';
import V2Components from '../../../v2/v2-components';

const legacyNames = {
  nameOnForm: 'emailAddress.email',
};

export class EmailAddress extends Component {
  constructor(props) {
    super(props);
    V2Components.register('EmailAddress', this);
    
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handleEmailBlur = this.handleEmailBlur.bind(this);
    this.validate = this.validate.bind(this);
  }
  
  handleEmailUpdate(fieldName, fieldValue) { // Don't need the field name returned by the field container
    this.props.updateEmailAddress(fieldValue);
  }
  
  handleEmailBlur(event) {
    if (this.validate().isValid && this.props.shouldCallAPIForMarketingPreferences) {
      this.props.checkEmailWithAPI(event.target.value);
    }
  }
  
  processErrorFieldName = errors => errors.map(error => ({
    fieldName: `emailAddress.${error.fieldName}`,
    errorCode: error.errorCode,
  }));
  
  validate() {
    const containerValidationResult = this.fieldContainer.validate();
    return {
      isValid: containerValidationResult.isValid,
      errors: (containerValidationResult.isValid)
        ? undefined : this.processErrorFieldName(containerValidationResult.errors),
    };
  }
  
  render() {
    const guestEmailFieldDefinition = {
      ...emailFieldDefinition,
      helperText: <Translation>email.address.instructions</Translation>,
    };
    
    return (
      <FieldContainer2 fieldUpdateDispatcher={this.handleEmailUpdate}>
        {(fieldContainer) => {
          this.fieldContainer = fieldContainer;
          return (
            <InputField
              fieldContainer={fieldContainer}
              legacyNames={legacyNames}
              fieldNamePrefix="emailAddress"
              value={this.props.emailAddress}
              definedField={guestEmailFieldDefinition}
              onBlur={this.handleEmailBlur}
              autoCompleteState={this.props.autoCompleteState}
            />
          );
        }}
      </FieldContainer2>
    );
  }
}

EmailAddress.propTypes = {
  emailAddress: PropTypes.string,
  autoCompleteState: PropTypes.string,
  checkEmailWithAPI: PropTypes.func.isRequired,
  updateEmailAddress: PropTypes.func.isRequired,
  shouldCallAPIForMarketingPreferences: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  autoCompleteState: getAutocompleteStatus(state),
  shouldCallAPIForMarketingPreferences: getShouldCallAPIForMarketingPreferences(state),
});

export default connect(mapStateToProps, {updateEmailAddress, checkEmailWithAPI})(EmailAddress);
